const productCallback = function(){
  console.log( "PRODUCT JS READY!" );
  
  const scrollIntoViewWithOffset = (selector, offset) => {
    window.scrollTo({
      behavior: 'smooth',
      top:
        document.querySelector(selector).getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    })
  };

   /* RATINGS */
  const ratingBlock = document.querySelector('.product .product__information .product-app .spr-starrating');
  
  const productTabs = document.querySelector('.product-tabs-section');
  
  const reviewsTab = document.querySelector('#reviews-tab');
  
  if(ratingBlock){
    
    const ratingLink = ratingBlock.querySelector('.link');

    if(ratingLink){
      
      const ratingText = ratingLink.querySelector('.visually-hidden');

      ratingText.innerHTML = ratingText.innerHTML.replace(' total', '');

      const ratingTextArray = ratingLink.textContent.split(" ");

      if(ratingTextArray[0] == "1"){
        ratingText.innerHTML = ratingText.innerHTML.replace('reviews', 'review');
      }
      
      // var el=document.querySelector('#shopify-product-reviews[data-id=\'4380357722155\']');el&&el.scrollIntoView();return false;
      
      ratingLink.removeAttribute('onclick');
      
      //ratingLink.replaceWith(ratingLink.cloneNode(true));
      
      //ratingLink.removeEventListener(event, listener, useCapture);
      
      ratingBlock.querySelector('.link').addEventListener('click', function(e){
      	
        e.preventDefault();
        
        reviewsTab.click();
        
        //productTabs.scrollIntoView({behavior: "smooth", block: "center"});
        
        scrollIntoViewWithOffset('.product-tabs-section', 170);
      });
    }

    else {

      ratingBlock.querySelectorAll('.spr-stars').forEach(element => { element.style.marginRight = 0; });
    }
  }
  /* END OF RATINGS */
};

if (document.readyState === "complete" || document.readyState === "interactive") {
	//setTimeout(productCallback, 1);
} else {
	//document.addEventListener("DOMContentLoaded", productCallback);
}
